import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { Content } from './ui/Content'

export class DeleteSimpleActionStore {
  constructor(private deleteAction: (isNextDelete: boolean) => void) {
    this._openModal()

    makeAutoObservable(this)
  }
  id = nanoid()

  private _openModal = () => {
    modalStore.addModal({
      id: this.id,
      title: 'Delete',
      ModalContent: () => <Content store={this} />,
      primaryAction: {
        text: 'Delete',
        onAction: this.onDelete,
      },
    })
  }

  onClose = () => {
    modalStore.closeModal(this.id)
  }

  onDelete = () => {
    this.deleteAction(this.isNextDelete)
    this.onClose()
  }

  isNextDelete = false
  setNextDelete = (value: boolean) => {
    this.isNextDelete = value
  }
}
